/**
 * @fileoverview Event Content Controller - controller for events
 *
 * @author Chris Williams (cwilliams@yext.com)
 */
goog.module('yext.social.post.EventContentController');
goog.module.declareLegacyNamespace();

const partners = goog.require('yext.social.partners');
const EventContentView = goog.require('yext.social.post.EventContentView');

/**
 * @constructor
 * @param {!Object<string, ?>} options
 */
const EventContentController = function(options) {
  options = options || {};

  /**
   * @private
   * @type {!jQuery}
   */
  this.$el_ = $(options['className'] || '.js-post-event-container');

  /**
   * @private
   * @type {!Object<string, ?>}
   */
  this.model_ = {
    'disabled': false,
    'hidden': false,
  };

  /**
   * @private
   * @type {EventContentView}
   */
  this.view_ = new EventContentView({
    'setEvent': this.setEvent_.bind(this),
    'removeEvent': this.removeEvent_.bind(this),
  });

  this.render_();
};

/**
 * @return {!Object}
 */
EventContentController.prototype.getData = function() {
  return $.extend(true, {}, {'event': this.model_['event']});
};

/**
 * @param {boolean} shouldDisable
 */
EventContentController.prototype.disable =
  function(shouldDisable) {
    if (shouldDisable) {
      this.model_['event'] = undefined;
    }
    this.model_['disabled'] = shouldDisable;

    this.render_();
  };

/** @param {boolean} shouldHide */
EventContentController.prototype.hide = function(shouldHide) {
  if (shouldHide) {
    this.model_['event'] = undefined;
  }
  this.model_['hidden'] = shouldHide;

  this.render_();
};

EventContentController.prototype.reset = function() {
  this.model_['event'] = undefined;

  this.render_();
};

/** @param {!Object<string, ?>} event */
EventContentController.prototype.setEvent = function(event) {
  // NOTE(pterry): this is a hack, but it's a working hack and a longer-term solution isn't worth it
  // because we're rewriting the frontend code for the social posting page. The reason it's
  // necessary is that the post history gets the local datetime in ET, and we want the copied post
  // to match. The backend contains the necessary logic to ensure that the event on the post
  // locations is on the same local time as we display in the frontend
  const convertToEtEquivalent = function(date) {
    return new Date(date.toLocaleString('en-US', {timeZone: 'America/New_York'}));
  };
  this.model_['event'] = event['title']
    ? {
      'title': event['title'],
      'startTime': convertToEtEquivalent(new Date(event['startTime'])),
      'endTime': event['endTime'] ? convertToEtEquivalent(new Date(event['endTime'])) : null,
    }
    : undefined;

  this.render_();
};

/**
 * @private
 * @param {!Object<string, ?>} event
 */
EventContentController.prototype.setEvent_ = function(event) {
  this.model_['event'] = event;

  this.render_();
};

/**
 * @private
 */
EventContentController.prototype.removeEvent_ = function() {
  delete this.model_['event'];

  this.render_();
};

/**
 * @private
 */
EventContentController.prototype.render_ = function() {
  var $newNode = this.view_.render(this.model_);
  this.$el_.replaceWith($newNode);
  this.$el_ = $newNode;
};

exports = EventContentController;
